import _ from 'lodash';
import ah from '../utils/ajax-helper'; // Get Interface List

export var getDataInterfaceList = function getDataInterfaceList(contextRoot, noProgress) {
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'name';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var parameters = {
      keyword: keyword,
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder
    };
    ah.get("".concat(contextRoot, "/data-interface/list"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // Edit Interface

export var editDataInterfaceAPI = function editDataInterfaceAPI(contextRoot, noProgress, interfaceData) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/data-interface/edit"), JSON.stringify(interfaceData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // search data source logs

export var getSearchDataSourceLogs = function getSearchDataSourceLogs(contextRoot, noProgress, sourceName, dateTime, sort) {
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 10;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'name';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var parameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      start: dateTime.from + ':00',
      end: dateTime.to + ':59'
    };
    ah.get("".concat(contextRoot, "/data-interface/").concat(sourceName, "/log/list"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // Get Data Processor List

export var getDataProcessorList = function getDataProcessorList(contextRoot, noProgress) {
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'target';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';

    var handeSortAddId = function handeSortAddId(field) {
      if (field === 'target' || field === 'source') return 'id.' + field;
      return field;
    };

    var parameters = {
      keyword: keyword,
      offset: offset,
      limit: limit,
      sort: handeSortAddId(sortField) + ':' + sortOrder
    };
    ah.get("".concat(contextRoot, "/data-processor/progress/list"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // search Data Processor log

export var getSearchDataProcessorLogs = function getSearchDataProcessorLogs(contextRoot, noProgress, target, source, dateTime, sort) {
  var offset = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var limit = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 10;
  return new Promise(function (resolve, reject) {
    var handeSortAddId = function handeSortAddId(field) {
      if (field === 'target' || field === 'source' || field === 'dataId') return 'id.' + field;
      return field;
    };

    var sortField = sort ? sort.field : 'name';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var parameters = {
      target: target,
      source: source,
      offset: offset,
      limit: limit,
      sort: handeSortAddId(sortField) + ':' + sortOrder,
      start: dateTime.from + ':00',
      end: dateTime.to + ':59'
    };
    ah.get("".concat(contextRoot, "/data-processor/log/list"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get data provide list

export var getDataProvideList = function getDataProvideList(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/data-provide/list"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};